const extractAndFormat = (input) => {
  if (!input) {
    return
  }
  const currency = input.match(/[^\d.]/)[0];
  const price = parseFloat(input.replace(currency, ''));
  if (Math.floor(price) === price) {
    return `${currency}${Math.floor(price)}`;
  }
  return `${currency}${price.toFixed(2)}`;
};

export default extractAndFormat;
